import { render, staticRenderFns } from "./ItemDetailView.vue?vue&type=template&id=2dcb4e67&"
import script from "./ItemDetailView.vue?vue&type=script&lang=js&"
export * from "./ItemDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports